import { render, staticRenderFns } from "./taskDeliverList-05.vue?vue&type=template&id=ed56a812&scoped=true"
import script from "./taskDeliverList-05.vue?vue&type=script&lang=js"
export * from "./taskDeliverList-05.vue?vue&type=script&lang=js"
import style0 from "./taskDeliverList-05.vue?vue&type=style&index=0&id=ed56a812&prod&lang=css"
import style1 from "./taskDeliverList-05.vue?vue&type=style&index=1&id=ed56a812&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed56a812",
  null
  
)

export default component.exports